// Imported by index.tsx, for its side effect: marks the page in the iOS and
// Android apps (never on the web site), so styles meant only for the app's web
// view can key on html[data-native-app]. It runs before the first render.
import { isCapacitorNative } from 'Utils/Constants';

if (isCapacitorNative()) {
  document.documentElement.setAttribute('data-native-app', 'true');
}
